export default __webpack_public_path__ + "static/media/checkbox-marked.edba6ea2.svg";